// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3GY7T","info":"UpdateTermsInfo_info__3CoI0"};